import { ApiCall } from '../ApiClient';
import { ResultData, WorkspaceLiteData } from '../ApiTypes';
import { AccountData } from './me';
import { OperationData } from './operations';

const get = <TResponse>(def: Omit<ApiCall<never, TResponse>, 'method'>): ApiCall<never, TResponse> =>
    Object.assign(def, { method: 'get' });

const post = <TResponse>(def: Omit<ApiCall<any, TResponse>, 'method'>): ApiCall<any, TResponse> =>
    Object.assign(def, { method: 'post' });

export interface SuggestedAccountData {
    readonly label: string;
    readonly domain: string;
    readonly corporate: number;
}

export interface SuggestedInviteData {
    id: string;
    name: string;
    email: string;
    domain: string;
    corporate: boolean;
}

export type UserMetricsData = Record<string, number>;
export type UserMetricMutation = readonly ['inc' | 'set', string, number];

export const internalEndpoints = {
    setup: {
        init: () => post<ResultData>({
            path: '/internal.setup.init'
        }),
        account: (name: string, surveyId?: string,) => post<Omit<AccountData, 'plan'> & { refreshToken: string }>({
            path: '/internal.setup.account',
            body: { name, surveyId },
        }),
        accountNext: (surveyId?: string,) => post<OperationData & { accountId: string }>({
            path: '/internal.setup.accountNext',
            body: { surveyId },
        }),
        trial: (type: string) => post<ResultData>({
            path: '/internal.setup.trial',
            body: { type },
        }),
    },
    notify: (body: ((string | number | boolean)[])[]) => post<ResultData>({
        path: '/internal.notify',
        body,
    }),
    metrics: {
        info: () => get<UserMetricsData>({
            path: '/internal.metrics.info',
        }),
        update: (body: UserMetricMutation[]) => post<ResultData>({
            path: '/internal.metrics.update',
            body,
        })
    },
    resolvePrivateWorkspace: () => post<WorkspaceLiteData>({
        path: '/internal.resolvePrivateWorkspace',
    }),
};
